import script from "./TocTree.vue?vue&type=script&setup=true&lang=js"
export * from "./TocTree.vue?vue&type=script&setup=true&lang=js"

import "./TocTree.vue?vue&type=style&index=0&id=045b2324&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-045b2324"]])

export default __exports__